import { Outlet } from "react-router-dom";

const Layout = () => {
    return (
        <div className="flex justify-center min-h-[100dvh]">
            <div
                id="container"
                className={`relative max-h-[100dvh] w-[100dvw] max-w-[768px] tablet:max-w-[100dvw] border-x tablet:border-0 overflow-auto`}
            >
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;
